import { http } from '@/lib/apiClient';

export type AttachmentEntityType = 'PO' | 'INVOICE' | 'VENDOR_KYC';
export interface AttachmentDto { id: string; entityType: AttachmentEntityType; entityId: string; fileName: string; mimeType: string; storageKey: string; fileSize: number; checksum: string; uploadedBy: string; createdAt: string }

export const attachmentsApi = {
  upload: (entityType: AttachmentEntityType, entityId: string, file: File) => {
    const form = new FormData();
    form.append('entityType', entityType);
    form.append('entityId', entityId);
    form.append('file', file);
    return http.post<AttachmentDto>('/api/v1/attachments', form);
  },
  metadata: (id: string) => http.get<AttachmentDto>(`/api/v1/attachments/${id}`),
  download: (id: string) => http.blob(`/api/v1/attachments/${id}/content`),
  delete: (id: string) => http.delete<void>(`/api/v1/attachments/${id}`),
};
